import React from 'react';
import PropTypes from 'prop-types';

import MapSettingsTile from '../MapSettingsTile';

import Icon from '../../../../assets/icon_map_settings_lock_active.svg';
import IconInactive from '../../../../assets/icon_map_settings_lock_inactive.svg';

const MapLockMarkerButton = props => {
    const { isActive, onToggle, ...remainingProps } = props;

    return (
        <MapSettingsTile
            className={'MapLockMarkerButton'}
            isActive={isActive}
            activeIcon={<Icon className={'MapLockMarkerButtonIcon'} />}
            inactiveIcon={<IconInactive className={'MapLockMarkerButtonIconInactive'} />}
            onToggle={onToggle}
            {...remainingProps}
        />
    );
};

MapLockMarkerButton.displayName = 'MapLockMarkerButton';

MapLockMarkerButton.defaultProps = {
    isActive: false,
};

MapLockMarkerButton.propTypes = {
    onToggle: PropTypes.func,
    isActive: PropTypes.bool,
};

export default MapLockMarkerButton;
